module.exports = __webpack_public_path__ + "media/packs/images/flags/EE-d77123f5eef4b9456d278c2ed51e1f1d.svg";